import { CahierJournalView } from '@teetsh/app/src/containers/CahierJournal/types';
import { useCJConfigurationDisplay } from '@teetsh/app/src/containers/CahierJournal/useCJConfigurationDisplay';
import { useMediaQuery } from 'react-responsive';

interface ScrollConfig {
  globalScroll: boolean;
}

export function useScrollConfig(view: CahierJournalView): ScrollConfig {
  const { globalScroll: globalScrollPref } = useCJConfigurationDisplay();
  const isSmallViewportHeight = useMediaQuery({ maxHeight: 700 });

  // Force global scroll for:
  // 1. 'day' view
  // 2. Small viewport heights (< 700px)
  // 3. Fallback on user preference
  const globalScroll =
    view === 'day' || isSmallViewportHeight || globalScrollPref;

  return {
    globalScroll,
  };
}
